import React from "react";
import styled from "styled-components";
import Banner from "../components/homeComponents/Banner";
import Banner2 from "../components/homeComponents/Banner2";
import TheLatest from "../components/homeComponents/TheLatest";
import LashStyles from "../components/homeComponents/LashStyles";
import LashPricing from "../components/homeComponents/LashPricing";
import PermanentMakeUp from "../components/homeComponents/PermanentMakeUp";
import AboutMe from "../components/homeComponents/AboutMe";
import FAQ from "../components/homeComponents/FAQ.jsx";
import Contact from "../components/homeComponents/Contact.jsx";

const Home = () => {
  return (
    <Container>
      <Banner />
      <TheLatest />
      <LashStyles />
      <LashPricing />
      <PermanentMakeUp />
      <AboutMe />
      <FAQ />
      <Contact />
    </Container>
  );
};
const Container = styled.div`
  padding: 00;
`;

export default Home;
